module.exports = __webpack_public_path__ + "static/img/Oak Oregano.fd0eac7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/color/Oak Oregano.jpg
// module id = X20n
// module chunks = 0